import React from 'react';
import PropTypes from 'prop-types';
import { FacebookShareButton } from 'react-share';
import useClipboard from 'react-use-clipboard';

import getConfig from '../../../../../../../../util/config';
import Button from '../../../../../../../../components/global/Button';
import LinkIcon from '../../../../../../../../components/icons/LinkIcon';
import FacebookSquareIcon from '../../../../../../../../components/icons/FacebookSquareIcon';
import { isNativeAppWebView } from '../../../../../../../../services/native-bridge/native-apps-interface';
import { removeHashes } from '../../../../../../../../util/text';

const propTypes = {
  album: PropTypes.shape({
    hash_code: PropTypes.string,
  }),
  albumId: PropTypes.string.isRequired,
  slideshow: PropTypes.shape({
    id: PropTypes.string.isRequired,
    embed_code: PropTypes.string,
  }).isRequired,
  onUnpublish: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const PublishedSlideshowShare = ({
  album,
  albumId,
  slideshow,
  onUnpublish,
  onDelete,
}) => {
  const shareUrl = `${
    getConfig().app.baseUrl
  }/albums/${albumId}/slideshow?present=1`;
  const [copied, setCopied] = useClipboard(shareUrl);
  const [copiedEmbed, setCopiedEmbed] = useClipboard(slideshow.embed_code);
  const isNativeView = isNativeAppWebView();

  return (
    <div className="published-slideshow-share">
      <h3>Share link</h3>
      <div className="d-flex mb-2">
        <Button
          onClick={setCopied}
          btnStyle="reset"
          className="slideshow-dropdown-action-button mr-1"
        >
          <div>
            <LinkIcon color="#0d84fe" size={20} />
          </div>
          {copied ? 'Copied!' : 'Copy'}
        </Button>
        {/* Do not render this in native. iOS does not allow facebook sharing */}
        {!isNativeView && (
          <FacebookShareButton
            url={shareUrl}
            className="slideshow-dropdown-action-button mr-1"
            quote="Hey check out my slideshow!"
            hashtag={album?.hash_code && `#${removeHashes(album?.hash_code)}`}
          >
            <div>
              <FacebookSquareIcon color="#0d84fe" size={20} />
            </div>
            Facebook
          </FacebookShareButton>
        )}
      </div>
      <h4 className="mb-0">Embed in webpage</h4>
      <p className="text-light text-sm">
        Paste your slideshow&apos;s HTML embed code into your webpage
      </p>
      <pre className="slideshow-share-embed-code-container">
        {slideshow.embed_code}
      </pre>
      <Button onClick={setCopiedEmbed} className="copy-embed-cta">
        {copiedEmbed ? 'Copied!' : `</> Copy HTML`}
      </Button>
      <hr className="my-2" />
      <div className="d-flex flex-column flex-md-row w-100">
        <Button
          btnBlock
          btnOutline
          btnStyle="danger"
          onClick={onUnpublish}
          className="mr-0 mr-md-1"
        >
          Unpublish
        </Button>
        <Button
          btnBlock
          btnOutline
          btnStyle="danger"
          onClick={onDelete}
          className="ml-0 ml-md-1 mt-md-0"
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

PublishedSlideshowShare.propTypes = propTypes;

export default PublishedSlideshowShare;
